import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './Incentives.scss';

const Incentives = ({ language }) => {
  useEffect(() => {
    document.title = `${process.env.REACT_APP_PAGES_INCENTIVES_TITLE} - Austin Energy EV Buyers Guide`;
  });

  return (
    <div className="incentives-catalog-container">
        <zr-incentives-catalog-widget
          lang={language.toLowerCase() ?? 'en'}
        ></zr-incentives-catalog-widget>
    </div>
  );
};

export default Incentives;

Incentives.propTypes = {
  language: PropTypes.string,
};
